function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState, useRef, useEffect } from 'react';
import { Datalayer } from '@finect/front-gtm';
import { isArray } from '@finect/front-utils/isArray';
import { ChevronLeft } from '@finect/tabular-icons/chevronLeft';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { TabItem, TabList, TabChild, ActionButton, TabsBlock, ListBlock } from './partials';
export var Tabs = function Tabs(_ref) {
  var _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 0 : _ref$initial,
    tabs = _ref.tabs,
    _onClick = _ref.onClick,
    onChange = _ref.onChange,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'terciaryD' : _ref$color,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'terciaryD' : _ref$titleColor,
    children = _ref.children,
    _ref$center = _ref.center,
    center = _ref$center === void 0 ? false : _ref$center,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'tabs' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$wrap = _ref.wrap,
    wrap = _ref$wrap === void 0 ? 'nowrap' : _ref$wrap;
  var withControls = wrap === 'nowrap' && ['chips', 'columns'].includes(variant);
  var containerRef = useRef();
  var refs = useRef(null);
  var _useState = useState(initial),
    _useState2 = _slicedToArray(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollLeft = _useState4[0],
    setScrollLeft = _useState4[1];
  var width = containerRef.current ? containerRef.current.offsetWidth : 0;
  var scrollWidth = containerRef.current ? containerRef.current.scrollWidth : 0;
  var isEnd = scrollLeft + width >= scrollWidth - 1;
  useEffect(function () {
    setTabIndex(initial);
  }, [initial]);
  var handleClick = function handleClick(tab, index) {
    setTabIndex(index);
    onChange && onChange(tab);
  };
  var handleScroll = function handleScroll(event) {
    setScrollLeft(event.currentTarget.scrollLeft);
  };
  var handleMove = function handleMove() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var accum = 0;
    var accums = [];
    var overflowIndex = 0;
    Object.values(refs).filter(function (item) {
      return item;
    }).forEach(function (item, index) {
      accum += item.offsetWidth;
      accums[index] = accum;
      if (!overflowIndex && accum > width) {
        overflowIndex = index;
      }
    });
    containerRef.current.scrollLeft += direction * accums[overflowIndex - 2] + 4 * 2 * (overflowIndex - 1);
  };
  var handleNext = function handleNext() {
    handleMove(1);
  };
  var handlePrev = function handlePrev() {
    handleMove(-1);
  };
  var displayTabs = tabs ? tabs : children && isArray(children) ? children.map(function (child, index) {
    return {
      id: index,
      title: child.props.title,
      name: child.props.name,
      icon: child.props.icon,
      disabled: child.props.disabled || false,
      to: child.props.to || null
    };
  }) : children ? [{
    id: '0',
    title: children.props.title,
    name: children.props.name,
    disabled: children.props.disabled || false,
    to: children.props.to || null
  }] : [];
  var tabsChildren = children && isArray(children) ? children : children ? [children] : [];
  var activeTab = displayTabs.find(function (_, index) {
    return index === tabIndex;
  });
  return React.createElement("div", null, React.createElement(TabsBlock, {
    $variant: variant
  }, withControls && scrollLeft > 0 ? React.createElement(ActionButton, {
    $variant: variant,
    $type: "prev",
    onClick: handlePrev
  }, React.createElement(ChevronLeft, {
    $variant: variant,
    size: "30px"
  })) : null, React.createElement(ListBlock, null, React.createElement(TabList, {
    center: center,
    $variant: variant,
    $wrap: wrap,
    ref: containerRef,
    onScroll: handleScroll
  }, displayTabs.map(function (tab, index) {
    return React.createElement(TabItem, {
      ref: function ref(_ref2) {
        refs[index] = _ref2;
      },
      key: "tab-item-".concat(index),
      tab: tab,
      variant: variant,
      size: size,
      tabIndex: index,
      active: !['links'].includes(variant) && index === tabIndex,
      titleColor: titleColor,
      color: color,
      disabled: tab.disabled || false,
      onClick: function onClick() {
        if (tab.disabled) return;
        _onClick && _onClick();
        handleClick(tab, index);
      }
    }, tab.title);
  }))), withControls && !isEnd ? React.createElement(ActionButton, {
    $variant: variant,
    $type: "next",
    onClick: handleNext
  }, React.createElement(ChevronRight, {
    $variant: variant,
    size: "30px"
  })) : null), tabsChildren.map(function (tabChild, tabChildIndex) {
    return React.createElement(TabChild, {
      $variant: variant,
      key: "tci-".concat(tabChildIndex),
      isVisible: tabIndex === tabChildIndex
    }, tabChild);
  }), activeTab ? React.createElement(Datalayer, {
    id: "FiEvent",
    type: "fiEvent",
    params: {
      category: 'Interaction',
      label: 'tab-change',
      action: activeTab.title
    }
  }) : null);
};